import { CURRENCY_CODE, SITES } from '../../../../constants';

export const initialState = {
  loading: false,
  errors: {}, // You can store the form errors here
  isActiveLoading: false, // You can store the active loading here
  isDeactiveLoading: false, // You can store the deactive loading here
  isResultsFound: false, // variable for result found here
  isSiteEntitlementsDetailsResultsFound: false, // variable for result found here
  errorModal: null, // variable for error modal here
  noDataFound: false, // variable for no data found here
  alertDialog: false, // variable for alert dialog here
  alertText: '', // variable for alert text here
  apiSuccessResponse: {
    activate: false,
    deactivate: false,
    create: false,
    update: false,
  }, // You can store the api success response here

  //Entitlements Details Data
  siteEntitlementDetailsData: [], // You can store the entitlements Details data here
  siteEntitlementDetailsLoading: false,
  //Entitlement Details Count
  siteEntitlemenDetailsCount: 0, // You can store the entitlements Details Data count here
  siteEntitlementCount: 0, // You can store the entitlements count here
  //Search Options Data
  searchOptions: {
    effectiveDate: new Date(), // You can store the effective date here
    statusId: SITES.DETAILS.statusActiveId, // You can store the status id here
    statusName: SITES.DETAILS.defaultStauts, // You can store the status name here
    status: [],
    serviceProductCodeContains: '',
    serviceProductNameContains: '',
    eid_Lockdown: SITES.DETAILS.anyDefaultVal, // You can store the eid_Lockdown id here
    eid_LockdownName: SITES.DETAILS.inputModalDefaultVal, // You can store the eid_LockdownName here
    voyix_Owned: SITES.DETAILS.anyDefaultVal, // You can store the voyix_Owned id here
    voyix_OwnedName: SITES.DETAILS.inputModalDefaultVal, // You can store the voyix_OwnedName here
  },
  tempAddModalValue: false,

  activeSearch: {
    siteId: '',
    effectiveDate: new Date(), // You can store the effective date here
    status: SITES.DETAILS.statusActiveId, // You can store the status id here
    eid_Lockdown: SITES.DETAILS.eid_Lockdown, // You can store the eid_Lockdown id here
    voyix_Owned: SITES.DETAILS.voyix_Owned, // You can store the eid_Lockdown id here
    serviceProductCode: '',
    serviceProductName: '',
  },

  serviceProductData: [],
  isServiceProductDataFound: true,
  isServiceProductLoading: false,
  serviceProductSelectedRow: {},
  serviceLevelData: [],
  entitlementId: '',
  currencyId: CURRENCY_CODE.usa,
  tempAddLoading: false,
  serviceProduuctRequestBody: {},
  totalRecordsProdData: 0,

  //User Details
  user: '',
  userId: 0,
  apiRes: '',

  //update site entitlement contract 
  updateButtonLoading: false,
  siteEntilementContracteUpdateData: null,
};
